import { isEmpty, isMatch, pick } from "lodash-es"
import { MULTI_ENTRIES_TYPE, NUMBER_CALCULATION_TYPE, TIME_DIFFERENCE_TYPE } from "Forms/FormElementTypes"

export const GENERAL_TASK_SUBFORM_ID = "general-task"
export const GENERAL_TASK_OPTION = { label: "General Task", value: GENERAL_TASK_SUBFORM_ID }

export const TASK_FORM_DELETED_QUESTIONS_NOTE = "The following questions were removed from the task form after answers were provided."

export const departmentIdentifier = (department) => pick(department, ["departmentId", "questionUUID"])

export const isMatchingDepartment = (department, lookupProperties) => (
  // isMatch will always return true when lookup properties is falsey or empty
  !isEmpty(lookupProperties) && isMatch(department, lookupProperties)
)

export const updateDepartmentInCollection = (departmentCollection, identifier, updatePropertiesFunction) => (
  departmentCollection.map((dept) => (
    isMatchingDepartment(dept, identifier)
      ? { ...dept, ...updatePropertiesFunction(dept) }
      : dept
  ))
)

export const taskAnswerValues = (answers) => Object.keys(answers).reduce((accumulator, answerUuid) => {
  const answer = answers[answerUuid]

  // Multi-entry question answers are arrays, unique among answers
  accumulator[answerUuid] = Array.isArray(answer) ? answer : answer.answer

  return accumulator
}, {})

export const questionTypeNeverAutosaves = (questionType) => {
  switch (questionType) {
  case MULTI_ENTRIES_TYPE:
  case NUMBER_CALCULATION_TYPE:
  case TIME_DIFFERENCE_TYPE:
    return true
  default:
    return false
  }
}
